import { ReloadOutlined } from '@ant-design/icons'
import { Button, Result } from 'antd'
import { useRouteError } from 'react-router-dom'

/** خطأ تحميل chunk بعد نشر نسخة جديدة (تبويب قديم يطلب ملفاً حُذف) */
function isStaleChunkError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err ?? '')
  return /dynamically imported module|Loading chunk|Importing a module script failed/i.test(msg)
}

/**
 * errorElement للراوتر: صفحة عربية لائقة بدل شاشة الخطأ التقنية.
 * لأخطاء الـ chunks القديمة بعد النشر تعرض «تحديث» — التحديث يجلب النسخة الجديدة دائماً.
 */
export default function RouteErrorPage() {
  const error = useRouteError()
  const stale = isStaleChunkError(error)

  return (
    <div dir="rtl" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Result
        status={stale ? 'info' : '500'}
        title={stale ? 'صدر تحديث جديد للنظام' : 'حدث خطأ غير متوقع'}
        subTitle={
          stale
            ? 'هذه الصفحة مفتوحة من نسخة قديمة — اضغط «تحديث» لتحميل النسخة الجديدة.'
            : 'جرّب تحديث الصفحة، وإذا تكرر الخطأ تواصل مع الإدارة.'
        }
        extra={[
          <Button
            key="reload"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={() => window.location.reload()}
          >
            تحديث الصفحة
          </Button>,
          <Button key="home" onClick={() => (window.location.href = '/')}>
            العودة للرئيسية
          </Button>,
        ]}
      />
    </div>
  )
}
